module.exports = __webpack_public_path__ + "static/media/Item_Weapon_DEagle_C.61f7dd98.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/item/Weapon/Handgun/Item_Weapon_DEagle_C.png
// module id = ./src/assets/item/Weapon/Handgun/Item_Weapon_DEagle_C.png
// module chunks = 0